import { render } from "./DatosBancarios.vue?vue&type=template&id=72acde59"
import script from "./DatosBancarios.vue?vue&type=script&lang=js"
export * from "./DatosBancarios.vue?vue&type=script&lang=js"

import exportComponent from "D:\\vento-proveedores\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__